module.exports = __webpack_public_path__ + "img/img-16c310.png";